import React from 'react';
import ChartCompo from '../ChartCompo';
import BiddingHistory from './BiddingHistory/BiddingHistory';
import RemainingTimeAuction from './RemainingTimeAuction/RemainingTimeAuction';

import SuperstarCard from './SuperstarCard/SuperstarCard';

const RightSideAuction = ({data}) => {


    return (
        <div>
            <RemainingTimeAuction AuctionData={data}/>
            <ChartCompo AuctionData={data}/>
            <SuperstarCard AuctionData={data}/>
            {/* <BiddingHistory AuctionData={data}/> */}
        </div>
    );
};

export default RightSideAuction;